import React, { Component } from 'react';
// import InfiniteScroll from 'react-infinite-scroll-component';
import PropTypes from 'prop-types';
import wiseRefController from '../../../../../utility/wiseRefController';
import { Close } from '../toolset/assets/icons';
import { black } from '../../../../../styling/theme';
import { SelectComponent } from './crossrefUtilities';
import DateSelection from '../inputComponents/DatePicker/date2';
import getToken from '../../../../../utility/getToken';
import { LoadingIcon } from '../../../../common/alerts/loading';
import journalTypes from '../../../../../constants/templateDictionaries/journalTypes';
import {
  ContentWrapper,
  SmallInputContainer,
  SmallInput1,
  SmallInput2,
  Filter,
  FilterContainer,
  Container,
  InputContainer,
  HeadingContainer,
  Smart,
  CloseOuter,
  Input,
  Button,
  InnerButton,
  ErrorMessage,
  ClearFields,
  Clear,
} from '../UI/referenceStyles/advancedWrapper';
import SnackBarAlerts from '../../../../common/snackBarAlerts/snackBarAlerts';

import Logger from '../../../../../utility/services/Logger';

const queryFields = [
  { field: 'title', title: 'Title' },

  {
    field: 'contributor',
    title: 'Contributors',
    note: 'Use space to seperate contributors.',
    placeholder: 'Authors, translators, editors, ...etc',
  },
  {
    field: 'container-title',
    title: 'Container Title',
    note: 'Title of journal, conference, ... etc!',
  },
  { field: 'affiliation', title: 'Affiliations' },
  { field: 'bibliographic', title: 'Random', note: 'ISSN, ISBN, DOI' },
];

const initialState = {
  results: null,
  waitingForRepond: false,
  bibliographic: '',
  type: '',
  title: '',
  contributor: '',
  'container-title': '',
  affiliation: '',
  sort: 'score' /* default is score */,
  order: 'asc' /* default is ascending */,
  'from-print-pub-date': '',
  'until-print-pub-date': '',
  validQuery: true,
  index: 0,
  fetchResponse: false,
  searchQuery: '',
  showSnackBar: false,
};

export default class AdvancedQuery2 extends Component {
  state = { ...initialState };

  clearForm = () => {
    this.setState({ ...initialState });
  };

  crossrefAPICall = async (searchQuery) => {
    this.setState({ waitingForRepond: true, searchQuery });
    try {
      const token = await getToken();
      const respondJSON = await wiseRefController.referenceType(
        {
          query: `${searchQuery.trim().split(' ').join('+')}`,
          offset: 0,
          row: 20,
          style: journalTypes.APA.refStyle,
          locale: journalTypes.APA.refLocale,
          isPDF: true,
        },
        token,
      );

      this.setState({ results: respondJSON.data, index: 0 });
    } catch (err) {
      Logger.LogError(err);
      this.setState({ showSnackBar: true });
    }
    this.setState({ waitingForRepond: false });
  };

  buildAdvancedQuery = () => {
    const curState = { ...this.state };
    let query = queryFields.filter((q) => curState[q.field].trim().length > 0);
    if (!query.length) return null;
    query = query.map(
      (q) =>
        `query.${q.field}=${curState[q.field].trim().split(' ').join('+')}`,
    );
    query = `${query.join('&')}&order=${curState.order}&sort=${curState.sort}`;

    const filters = [];
    if (curState.type && curState.type.value.length > 0) {
      filters.push(`type:${curState.type.value}`);
    }
    if (curState['from-print-pub-date'] !== '') {
      filters.push(
        `from-print-pub-date:${curState['from-print-pub-date']
          .toISOString()
          .substring(0, 10)}`,
      );
    }
    if (curState['until-print-pub-date'] !== '') {
      filters.push(
        `until-print-pub-date:${curState['until-print-pub-date']
          .toISOString()
          .substring(0, 10)}`,
      );
    }
    if (!filters.length) return query;

    return `${query}&filter=${filters}`;
  };

  isValidQuery = () => {
    const curState = { ...this.state };
    const temp = queryFields.filter((q) => curState[q.field].trim().length > 0);
    return temp.length > 0;
  };

  handleSubmit = () => {
    if (!this.isValidQuery()) {
      this.setState({ validQuery: false });

      return;
    }
    this.setState({ validQuery: true });

    const curState = this.state;

    const q = this.buildAdvancedQuery(curState);

    this.crossrefAPICall(q);
  };

  handleFormChange = (field, value) => {
    this.setState({ [field]: value });
  };

  fetchCitations = async () => {
    const { searchQuery, index, results } = this.state;
    this.setState({ fetchResponse: true });
    try {
      const token = await getToken();
      const respondJSON = await wiseRefController.referenceType(
        {
          query: `${searchQuery.trim().split(' ').join('+')}`,
          offset: index + 20,
          row: 20,
          style: journalTypes.APA.refStyle,
          locale: journalTypes.APA.refLocale,
          isPDF: true,
        },
        token,
      );

      this.setState({
        results: results.concat(respondJSON.data),
        index: index + 20,
      });
    } catch (err) {
      Logger.LogError(err);
      this.setState({ showSnackBar: true });
    }
    this.setState({ fetchResponse: false });
  };

  handleClick = (el) => {
    const { handleUpdateReference, closeModal } = this.props;
    handleUpdateReference(el);
    closeModal();
  };

  keyDown = (event) => {
    event.stopPropagation();
  };

  handleCloseSnackBar = () => {
    this.setState({ showSnackBar: false });
  };

  render() {
    const curState = { ...this.state };
    const { closeModal, switchMode } = this.props;
    return (
      <Container>
        <SnackBarAlerts
          showSnackBar={curState.showSnackBar}
          handleClose={this.handleCloseSnackBar}
          snackBarMessage="Provide Valid Information"
          snackBarType="error"
        />
        <HeadingContainer>
          <Smart>SMART</Smart>
          <CloseOuter data-testid="close" onClick={closeModal}>
            <Close fill={black} height="18px" width="18px" />
          </CloseOuter>
        </HeadingContainer>
        <InputContainer>
          <Input
            onKeyDown={this.keyDown}
            value={curState.bibliographic}
            type="text"
            placeholder="Search titles, authors, doi, isbn, ... etc!"
            onChange={({ target: { value } }) =>
              this.handleFormChange('bibliographic', value)
            }
            data-testid="input"
          />
        </InputContainer>
        <SmallInputContainer>
          <SmallInput1
            onKeyDown={this.keyDown}
            value={curState.contributor}
            type="text"
            placeholder="Authors name"
            onChange={({ target: { value } }) =>
              this.handleFormChange('contributor', value)
            }
          />
          <SmallInput2
            onKeyDown={this.keyDown}
            value={curState['container-title']}
            type="text"
            placeholder="Journal/Organization Title"
            onChange={({ target: { value } }) =>
              this.handleFormChange('container-title', value)
            }
          />
        </SmallInputContainer>
        <SmallInputContainer>
          <SmallInput1
            onKeyDown={this.keyDown}
            value={curState.affiliation}
            type="text"
            placeholder="Affiliations"
            onChange={({ target: { value } }) =>
              this.handleFormChange('affiliation', value)
            }
          />
        </SmallInputContainer>
        <Filter>Filters</Filter>
        <FilterContainer>
          {SelectComponent(curState.type, 'type', this.handleFormChange, false)}
          <DateSelection
            date={curState['from-print-pub-date']}
            handleChange={(date) => {
              this.handleFormChange('from-print-pub-date', date);
            }}
            placeholderText="Start Date"
          />
          <DateSelection
            date={curState['until-print-pub-date']}
            handleChange={(date) =>
              this.handleFormChange('until-print-pub-date', date)
            }
            placeholderText="End Date"
          />
        </FilterContainer>
        {!curState.validQuery && (
          <ErrorMessage noResults={false}>
            Enter at least one search keyword!
          </ErrorMessage>
        )}
        <ClearFields>
          <Button>
            <InnerButton
              onClick={
                curState.waitingForRepond ? null : (e) => this.handleSubmit(e)
              }
              isValidQuery={this.isValidQuery()}
              data-testid="search"
            >
              {curState.waitingForRepond ? <LoadingIcon /> : <div>Search</div>}
            </InnerButton>
          </Button>
          <Clear
            onClick={this.clearForm}
            isValidQuery={
              this.isValidQuery() ||
              curState.type ||
              curState['from-print-pub-date'] > 0 ||
              curState['until-print-pub-date'] > 0
            }
          >
            Reset
          </Clear>
          <Clear margin="16px" isValidQuery onClick={() => switchMode('basic')}>
            Basic
          </Clear>
        </ClearFields>
        {curState.results &&
          Object.prototype.toString.call(curState.results) !==
            '[object Object]' && (
            <ContentWrapper>
              {/* <InfiniteScroll
                dataLength={curState.results.length}
                next={this.fetchCitations}
                hasMore
                loader={
                  curState.results.length > 5 &&
                  curState.fetchResponse && <LoadingIcon />
                }
                height={curState.results.length > 5 && '406px'}
              >
                {curState.results.map((el) => (
                  <TextContainer
                    key={el}
                    value={el}
                    onClick={() => this.handleClick(el)}
                    data-testid="list"
                  >
                    <Text>{el}</Text>

                    <Check />
                  </TextContainer>
                ))}

                {curState.results.length === 0 && (
                  <ErrorMessage noResults>No Results!</ErrorMessage>
                )}
              </InfiniteScroll> */}
            </ContentWrapper>
          )}
        {Object.prototype.toString.call(curState.results) ===
          '[object Object]' && (
          <ErrorMessage noResults>No Results!</ErrorMessage>
        )}
      </Container>
    );
  }
}

AdvancedQuery2.propTypes = {
  closeModal: PropTypes.func.isRequired,
  handleUpdateReference: PropTypes.func.isRequired,
};
